import DataTable from 'react-data-table-component'
import OperatorsApiManager from '../../api/services/OperatorsApiManager'
import { useState, useEffect, useRef } from 'react'
import {
    Button,
    Dropdown,
    Form,
    Modal,
    OverlayTrigger,
    ProgressBar,
    Tooltip,
} from 'react-bootstrap'
import { ToastContainer, toast } from 'react-toastify'
import Papa from 'papaparse'
import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'

function Usuarios() {
    const { t } = useTranslation()
    const [inputFile, setInputFile] = useState(null)
    const [showDeleteUser, setShowDeleteUser] = useState(false)
    const [showChangePass, setShowChangePass] = useState(false)
    const [showChangeRole, setShowChangeRole] = useState(false)
    const [showImportUser, setShowImportUser] = useState(false)
    const [showAddUser, setShowAddUser] = useState(false)
    const [password, setPassword] = useState('')
    const [username, setUsername] = useState('')
    const [rol, setRol] = useState('operators-user')
    const [selectedUser, setSelectedUser] = useState(null)
    const [selectedOperator, setSelectedOperator] = useState(null)
    const [usuarios, setUsuarios] = useState([])
    const [usuariosData, setUsuariosData] = useState([])

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [progress, setProgress] = useState(0)
    const paginacionOpciones = {
        rowsPerPageText: t('paginator.rowsPerPageText'),
        rangeSeparatorText: t('paginator.rangeSeparatorText'),
        selectAllRowsItemText: t('paginator.selectAllRowsItemText'),
    }
    const handleFileUpload = (e) => {
        const file = e.target.files[0]
        if (!file) return

        setLoading(true)

        // Parsear el CSV
        Papa.parse(file, {
            header: true, // Si la primera fila son headers (ej: {nombre: "Juan", edad: "30"})
            skipEmptyLines: true,
            complete: (results) => {
                setData(results.data) // Guardar datos en el estado
                setShowImportUser(true)
                setLoading(false)
            },
            error: (error) => {
                console.error('Error al parsear CSV:', error)
                setLoading(false)
            },
        })
    }

    const processData = async () => {
        if (!data.length) return

        setLoading(true)
        setProgress(0)

        for (let i = 0; i < data.length; i++) {
            const item = data[i]
            try {
                if (item.exists.toLowerCase() === 'true') {
                    let role = ''

                    if (item.rol === 'User-subscriber') {
                        role = 'operators-user'
                    } else if (item.rol === 'Admin-package') {
                        role = 'operators-operator_admin'
                    } else {
                        toast.error(
                            t('validations.invalid_role', {
                                role: item.rol,
                            })
                        )

                        continue
                    }

                    const response =
                        await OperatorsApiManager.editUserInOperator(
                            item.username,
                            {
                                new_role: role,
                            }
                        )
                    if (response) {
                        toast.success(
                            t('user_added', {
                                username: item.username,
                            })
                        )
                    }
                } else {
                    let role = ''

                    if (item.rol === 'User-subscriber') {
                        role = 'operators-user'
                    } else if (item.rol === 'Admin-package') {
                        role = 'operators-operator_admin'
                    } else {
                        toast.error(
                            t('validations.invalid_role', {
                                role: item.rol,
                            })
                        )

                        continue
                    }

                    const data = {
                        email: item.mail,
                        username: item.username,
                        password: item.password,
                        group_role: role,
                    }
                    const response =
                        await OperatorsApiManager.createUserInOperator(data)
                    if (response) {
                        toast.success(
                            t('user_created', {
                                username: item.username,
                            })
                        )
                    }
                }
                setProgress(((i + 1) / data.length) * 100)
            } catch (error) {
                console.error(
                    t('validations.error_csv_item', {
                        error: error.message,
                        index: i + 1,
                    })
                )
                toast.error(
                    t('validations.error_csv_item', {
                        error: error.message,
                        index: i + 1,
                    })
                )
            }
        }

        setLoading(false)
        toast.info(t('alerts.csv_imported'))
        setShowImportUser(false)
        setData([])
        setProgress(0)
    }

    useEffect(() => {
        setInputFile(document.getElementById('input-file'))
        var operatorData = localStorage.getItem('operador')
        var operator = JSON.parse(operatorData)

        fetchUsuarios()
        setSelectedOperator(operator)
    }, [])
    async function fetchUsuarios() {
        const usuariosItems = await OperatorsApiManager.getOperatorUsers()

        setUsuarios(usuariosItems)
        setUsuariosData(usuariosItems)
    }
    const handleDeleteUser = async (user) => {
        const response = await OperatorsApiManager.deleteUserInOperator(
            user.uid
        ).catch((error) => {
            console.error(error)
            setShowDeleteUser(false)
            toast.error(error.message)
        })

        if (response) {
            setUsuarios((prevUsuarios) =>
                prevUsuarios.filter((item) => item.uid !== user.uid)
            )
            setShowDeleteUser(false)

            toast.success(t('alerts.user_deleted'))
        }
    }

    const setRolFromName = (rolName) => {
        if (rolName === 'Suscriptor') {
            setRol('operators-user')
        } else {
            setRol('operators-operator_admin')
        }
    }
    const getRolFromId = (rolId) => {
        if (rolId === 'operators-user') {
            return 'Suscriptor'
        } else {
            return 'Operador'
        }
    }

    const handleChangePass = async (user) => {
        if (password) {
            const response = await OperatorsApiManager.editUserInOperator(
                user.uid,
                {
                    new_password: password,
                }
            ).catch((error) => {
                console.error(error)
                setShowChangePass(false)
                toast.error(error.message)
            })

            if (response) {
                setShowChangePass(false)
                setPassword('')
                toast.success(t('alerts.password_updated'))
            }
        }
    }
    const handleUpload = (event) => {
        event.preventDefault()
        inputFile?.click()
    }
    const handleDownloadFile = (event) => {
        event.preventDefault()
        const url = '/assets/usuarios.csv'
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'usuarios.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        toast.info(t('alerts.downloading_csv'))
        setTimeout(() => {
            toast.info(t('alerts.download_csv'))
        }, 2000)
    }
    const handleChangeRole = async (user) => {
        if (rol) {
            const response = await OperatorsApiManager.editUserInOperator(
                user.uid,
                {
                    new_role: rol,
                }
            ).catch((error) => {
                console.error(error)
                setShowChangeRole(false)
                toast.error(error.message)
            })

            if (response) {
                setShowChangeRole(false)
                user.role = getRolFromId(rol)
                toast.success(t('alerts.role_updated'))
            }
        }
    }

    const handleAddUser = async () => {
        if (rol && username) {
            const response = await OperatorsApiManager.editUserInOperator(
                username,
                {
                    new_role: rol,
                }
            ).catch((error) => {
                console.error(error)
                setShowAddUser(false)
                toast.error(error.message)
            })

            if (response) {
                setShowAddUser(false)
                fetchUsuarios()
                setUsername('')
                setRol('operators-user')
                toast.success(t('alerts.user_added'))
            }
        }
    }

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.uid,
            sortable: true,
        },
        {
            name: t('username_title'),
            selector: (row) => row.username,
            sortable: true,
        },
        {
            name: t('rol_title'),
            selector: (row) => row.role,
            sortable: true,
        },
        {
            name: t('updated_at_title'),
            selector: (row) => row.changed,
            sortable: true,
        },
        {
            name: t('created_at_title'),
            selector: (row) => row.created,
            sortable: true,
        },
        {
            name: t('options_title'),
            selector: (row) => (
                <div>
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-disabled">
                                {t('change_rol')}
                            </Tooltip>
                        }
                    >
                        <span className="d-inline-block">
                            <Button
                                variant="btn-rounded outline-secondary btn-icon"
                                onClick={(event) => {
                                    event.preventDefault()
                                    setRolFromName(row.role)
                                    setShowChangeRole(true)
                                    setSelectedUser(row)
                                }}
                            >
                                <i className="mdi mdi-security btn-icon-prepend text-info"></i>
                            </Button>
                        </span>
                    </OverlayTrigger>

                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-disabled">
                                {t('change_password')}
                            </Tooltip>
                        }
                    >
                        <span className="d-inline-block">
                            <Button
                                variant="btn-rounded outline-secondary btn-icon"
                                onClick={(event) => {
                                    event.preventDefault()
                                    setShowChangePass(true)
                                    setSelectedUser(row)
                                }}
                            >
                                <i className="mdi mdi-lock-reset btn-icon-prepend text-warning"></i>
                            </Button>
                        </span>
                    </OverlayTrigger>

                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-disabled">
                                {t('delete')}
                            </Tooltip>
                        }
                    >
                        <span className="d-inline-block">
                            <Button
                                variant="btn-rounded outline-secondary btn-icon"
                                onClick={(event) => {
                                    event.preventDefault()
                                    setShowDeleteUser(true)
                                    setSelectedUser(row)
                                }}
                            >
                                <i className="mdi mdi-delete btn-icon-prepend text-danger"></i>
                            </Button>
                        </span>
                    </OverlayTrigger>
                </div>
            ),
            sortable: false,
        },
    ]
    return (
        <div>
            <ToastContainer />
            <div className="page-header">
                <h3 className="page-title">{selectedOperator?.group_name}</h3>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/operadores" className="breadcrumb-link">
                                {t('operators_title')}
                            </Link>
                        </li>
                        <li
                            className="breadcrumb-item active"
                            aria-current="page"
                        >
                            {t('users_title')}
                        </li>
                    </ol>
                </nav>
            </div>
            <div className="row">
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col mt-2">
                                    <h4 className="card-title">
                                        {t('users_operator_title')}
                                    </h4>
                                </div>
                                <div className="col-2">
                                    <input
                                        id="input-file"
                                        className="d-none"
                                        onInput={handleFileUpload}
                                        disabled={loading}
                                        accept="text/csv"
                                        type="file"
                                    />
                                    <Dropdown>
                                        <Dropdown.Toggle>
                                            {t('options_title')}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item>
                                                <Link
                                                    className="col col-sm-6 col-md-4 col-lg-3"
                                                    to="/operadores/usuarios/crear"
                                                >
                                                    <Button
                                                        className="ml-auto"
                                                        variant="primary btn-icon-text"
                                                    >
                                                        <i className="mdi mdi-plus btn-icon-prepend"></i>
                                                        {t('add_new_user')}
                                                    </Button>
                                                </Link>
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                <Button
                                                    className="ml-auto"
                                                    variant="outline-success btn-icon-text"
                                                    onClick={handleUpload}
                                                >
                                                    <i className="mdi mdi-upload btn-icon-prepend"></i>
                                                    {t('import_users')}
                                                </Button>
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                <Button
                                                    className="ml-auto"
                                                    variant="outline-warning btn-icon-text"
                                                    onClick={handleDownloadFile}
                                                >
                                                    <i className="mdi mdi-download btn-icon-prepend"></i>
                                                    {t(
                                                        'import_users_description'
                                                    )}
                                                </Button>
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                <Button
                                                    className="ml-auto"
                                                    variant="success btn-icon-text"
                                                    onClick={(event) => {
                                                        event.preventDefault()
                                                        setRol('operators-user')
                                                        setShowAddUser(true)
                                                    }}
                                                >
                                                    <i className="mdi mdi-plus btn-icon-prepend"></i>
                                                    {t('existing_user')}
                                                </Button>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="row">
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t(
                                                'search_placeholder'
                                            )}
                                            onChange={(e) => {
                                                if (e.target.value === '') {
                                                    setUsuarios(usuariosData)
                                                    return
                                                }

                                                const searchTerm =
                                                    e.target.value.toLowerCase()
                                                const filteredUsuarios =
                                                    usuariosData.filter(
                                                        (usuario) =>
                                                            usuario.username
                                                                .toLowerCase()
                                                                .includes(
                                                                    searchTerm
                                                                ) ||
                                                            usuario.uid
                                                                .toLowerCase()
                                                                .includes(
                                                                    searchTerm
                                                                )
                                                    )
                                                setUsuarios(filteredUsuarios)
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 text-right text-center mt-4">
                                        <span className="text-muted">
                                            {t('users_count')}
                                            <strong>
                                                {usuariosData.length}
                                            </strong>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <DataTable
                                columns={columns}
                                data={usuarios}
                                paginationComponentOptions={paginacionOpciones}
                                pagination
                            />
                        </div>
                    </div>
                </div>
                {/* Modal import user starts */}
                <Modal
                    show={showImportUser}
                    onHide={() => setShowImportUser(false)}
                    aria-labelledby="example-modal-sizes-title-md"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t('import_users_description_popup')}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            <Trans
                                i18nKey="import_users_description_popup_2"
                                values={{
                                    operator: selectedOperator?.group_name,
                                }}
                            ></Trans>
                        </p>

                        {data.length > 0 && (
                            <p>
                                {t('total_users_import')}
                                {data.length}
                            </p>
                        )}
                        {loading && (
                            <div>
                                <ProgressBar
                                    variant="info"
                                    className="progress-lg"
                                    now={progress}
                                    label={`${Math.round(progress)}% ${t(
                                        'completed'
                                    )}`}
                                />
                            </div>
                        )}
                    </Modal.Body>

                    <Modal.Footer className="flex-wrap">
                        <Button
                            variant="primary m-2"
                            loading={loading}
                            onClick={processData}
                        >
                            {loading ? t('proccessing') : t('import')}
                        </Button>
                        <Button
                            variant="light m-2"
                            onClick={() => setShowImportUser(false)}
                        >
                            {t('button.cancel')}
                        </Button>
                    </Modal.Footer>
                </Modal>
                {/* Modal import user Ends */}

                {/* Modal delete user starts */}
                <Modal
                    show={showDeleteUser}
                    onHide={() => setShowDeleteUser(false)}
                    aria-labelledby="example-modal-sizes-title-md"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{t('delete_user_title')}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            <Trans
                                i18nKey="delete_user_description"
                                values={{
                                    user: selectedUser?.username,
                                    operator: selectedOperator?.group_name,
                                }}
                            ></Trans>
                        </p>
                    </Modal.Body>

                    <Modal.Footer className="flex-wrap">
                        <Button
                            variant="danger m-2"
                            onClick={() => handleDeleteUser(selectedUser)}
                        >
                            {t('button.delete')}
                        </Button>
                        <Button
                            variant="light m-2"
                            onClick={() => setShowDeleteUser(false)}
                        >
                            {t('button.cancel')}
                        </Button>
                    </Modal.Footer>
                </Modal>
                {/* Modal delete user Ends */}

                {/* Modal change password starts */}
                <Modal
                    show={showChangePass}
                    onHide={() => setShowChangePass(false)}
                    aria-labelledby="example-modal-sizes-title-md"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t('change_password_for')}
                            <strong>{selectedUser?.username}</strong>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form.Control
                            type="password"
                            className="form-control"
                            value={password}
                            required
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder={t('password_placeholder')}
                        />
                    </Modal.Body>

                    <Modal.Footer className="flex-wrap">
                        <Button
                            variant="primary m-2"
                            onClick={() => handleChangePass(selectedUser)}
                        >
                            {t('button.change')}
                        </Button>
                        <Button
                            variant="light m-2"
                            onClick={() => setShowChangePass(false)}
                        >
                            {t('button.cancel')}
                        </Button>
                    </Modal.Footer>
                </Modal>
                {/* Modal  change password Ends */}

                {/* Modal change role starts */}
                <Modal
                    show={showChangeRole}
                    onHide={() => setShowChangeRole(false)}
                    aria-labelledby="example-modal-sizes-title-md"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t('change_rol_for')}
                            <strong>{selectedUser?.username}</strong>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form.Select
                            aria-label={t('rol_title')}
                            className="form-select"
                            value={rol}
                            required
                            onChange={(e) => setRol(e.target.value)}
                        >
                            <option id="operators-user" value="operators-user">
                                Suscriptor
                            </option>
                            <option
                                id="operators-operator_admin"
                                value="operators-operator_admin"
                            >
                                Operador
                            </option>
                        </Form.Select>
                    </Modal.Body>

                    <Modal.Footer className="flex-wrap">
                        <Button
                            variant="primary m-2"
                            onClick={() => handleChangeRole(selectedUser)}
                        >
                            {t('button.change')}
                        </Button>
                        <Button
                            variant="light m-2"
                            onClick={() => setShowChangeRole(false)}
                        >
                            {t('button.cancel')}
                        </Button>
                    </Modal.Footer>
                </Modal>
                {/* Modal  change role Ends */}

                {/* Modal add user exists starts */}
                <Modal
                    show={showAddUser}
                    onHide={() => setShowAddUser(false)}
                    aria-labelledby="example-modal-sizes-title-md"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t('add_user_existing_in_operator')}
                            {selectedOperator?.name}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form.Control
                            type="text"
                            className="form-control"
                            value={username}
                            required
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder={t('username_placeholder')}
                        />

                        <Form.Select
                            aria-label={t('rol_title')}
                            className="form-select"
                            value={rol}
                            required
                            onChange={(e) => setRol(e.target.value)}
                        >
                            <option id="operators-user" value="operators-user">
                                Suscriptor
                            </option>
                            <option
                                id="operators-operator_admin"
                                value="operators-operator_admin"
                            >
                                Operador
                            </option>
                        </Form.Select>
                    </Modal.Body>

                    <Modal.Footer className="flex-wrap">
                        <Button
                            variant="primary m-2"
                            onClick={() => handleAddUser(selectedUser)}
                        >
                            {t('button.add')}
                        </Button>
                        <Button
                            variant="light m-2"
                            onClick={() => setShowAddUser(false)}
                        >
                            {t('button.cancel')}
                        </Button>
                    </Modal.Footer>
                </Modal>
                {/* Modal add user exists  Ends */}
            </div>
        </div>
    )
}

export default Usuarios
